// extracted by mini-css-extract-plugin
export var chevron = "_k3-2";
export var dropdownItems = "_k3-0";
export var item = "_k3-1";